import React from 'react';
import instructorData from '../../data/instructor/instructor.json'; // adjust file name/path if needed
// import courseData from '../../data/course/slider.json';
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
// import Swiper from 'react-id-swiper';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/instructor.js';

function InstructorDetails() {
    const { id } = useParams();

    const instructor = instructorData.find((item) => item.id === id);

    // const courses = courseData.dataList || [];

    const settings = {
        slidesPerView: 3,
        loop: true,
        speed: 1000,
        autoplay: false,
        spaceBetween: 30,
        watchSlidesVisibility: true,
        pagination: {
            el: '.slider-dot.text-center',
            clickable: true
        },
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            576: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 3
            }
        }
    };

    if (!instructor) {
        return (
            <Styles>
                <div className="main-wrapper instructor-details-page">
                    <HeaderTwo />
                    <BreadcrumbBox title="Instructor Not Found" />
                    <div className="text-center py-5">
                        <h3>Instructor not found</h3>
                    </div>
                    <FooterTwo />
                </div>
            </Styles>
        );
    }

    return (
        <Styles>
            <div className="main-wrapper instructor-details-page">
                <HeaderTwo />

                <BreadcrumbBox title={instructor.personName} />

                <section className="instructor-details-area">
                    <Container>
                        <Row>
                            <Col md="6">
                                <div className="instructor-img mr-5">
                                    <img
                                        src={`/assets/images/${instructor.personImage}`}
                                        alt={instructor.personName}
                                        className="img-fluid"
                                    />



                                    {/* <ul className="social list-unstyled list-inline">
                                        <li className="list-inline-item">
                                            <a href={instructor.socialLinks.facebook} target="_blank" rel="noreferrer">
                                                <i className="fab fa-facebook-f"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href={instructor.socialLinks.twitter} target="_blank" rel="noreferrer">
                                                <i className="fab fa-twitter"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href={instructor.socialLinks.linkedin} target="_blank" rel="noreferrer">
                                                <i className="fab fa-linkedin-in"></i>
                                            </a>
                                        </li>
                                        <li className="list-inline-item">
                                            <a href={instructor.socialLinks.youtube} target="_blank" rel="noreferrer">
                                                <i className="fab fa-youtube"></i>
                                            </a>
                                        </li>
                                    </ul> */}
                                </div>
                            </Col>

                            <Col md="6">
                                <div className="instructor-content mt-5">
                                    <h4>{instructor.personName}</h4>
                                    <span>{instructor.personTitle}</span>
                                    <p>
                                        {instructor.personName} is a dedicated faculty member committed to
                                        delivering quality education, practical learning, and strong academic
                                        guidance to students. With experience in teaching and mentoring,
                                        {` ${instructor.personName.split(" ")[0]} `} focuses on helping students
                                        build confidence, subject knowledge, and professional skills for future success.
                                    </p>
                                </div>

                                <div className="qual-expe d-flex">
                                    <div className="qualification">
                                        <h5>Qualifications</h5>
                                        <div className="qual-expe-box">
                                            <h6>Recognized University</h6>
                                            <p>Master’s Degree in Relevant Subject</p>
                                        </div>
                                        <div className="qual-expe-box">
                                            <h6>Professional Training</h6>
                                            <p>Advanced Teaching and Academic Development</p>
                                        </div>
                                    </div>

                                    <div className="experiance">
                                        <h5>Experience</h5>
                                        <div className="qual-expe-box">
                                            <h6>Academic Teaching</h6>
                                            <p>5+ Years of Teaching Experience</p>
                                        </div>
                                        <div className="qual-expe-box">
                                            <h6>Student Mentorship</h6>
                                            <p>Career Guidance and Skill Development</p>
                                        </div>
                                    </div>

                                </div>
                                <ul className="list-unstyled getintouch" >
                                    <li style={{fontSize:"16px"}}><i className="las la-phone"></i>Contact: +91 98765 43210</li>
                                    <li style={{fontSize:"16px"}}><i className="lar la-envelope"></i> E-mail: info@college.com</li>
                                    <li style={{fontSize:"16px"}}><i className="lab la-skype"></i> {instructor.personName.toUpperCase().replace(/\s+/g, " ")}</li>
                                </ul>
                            </Col>

                            {/* <Col md="12">
                                <div className="instructor-course-title">
                                    <h5>Courses by {instructor.personName}</h5>
                                </div>

                                <div className="instructor-course-slider">
                                    <Swiper {...settings}>
                                        {courses.map((data, i) => (
                                            <div className="course-item" key={i}>
                                                <Link to={`/course-details/${data.id}`}>
                                                    <div
                                                        className="course-image"
                                                        style={{ backgroundImage: `url(/assets/images/${data.imgUrl})` }}
                                                    >
                                                        <div className="author-img d-flex">
                                                            <div className="title">
                                                                <p>{data.authorName}</p>
                                                                <span>{data.authorCourses}</span>
                                                            </div>
                                                        </div>
                                                        <div className="course-price">
                                                            <p>{data.price}</p>
                                                        </div>
                                                    </div>
                                                </Link>

                                                <div className="course-content">
                                                    <h6 className="heading">
                                                        <Link to={`/course-details/${data.id}`}>
                                                            {data.courseTitle}
                                                        </Link>
                                                    </h6>
                                                    <p className="desc">{data.courseDesc}</p>

                                                    <div className="course-face d-flex justify-content-between">
                                                        <div className="duration">
                                                            <p><i className="las la-clock"></i>120</p>
                                                        </div>
                                                        <div className="rating">
                                                            <ul className="list-unstyled list-inline">
                                                                <li className="list-inline-item"><i className="las la-star"></i></li>
                                                                <li className="list-inline-item"><i className="las la-star"></i></li>
                                                                <li className="list-inline-item"><i className="las la-star"></i></li>
                                                                <li className="list-inline-item"><i className="las la-star"></i></li>
                                                                <li className="list-inline-item"><i className="las la-star-half-alt"></i></li>
                                                                <li className="list-inline-item">(4.5)</li>
                                                            </ul>
                                                        </div>
                                                        <div className="student">
                                                            <p><i className="las la-chair"></i>60</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Swiper>
                                </div>
                            </Col> */}
                        </Row>
                    </Container>
                </section>

                <FooterTwo />
            </div>
        </Styles>
    );
}

export default InstructorDetails;